import { render, staticRenderFns } from "./supplierBankAction.vue?vue&type=template&id=2dfed0a6&scoped=true"
import script from "./supplierBankAction.vue?vue&type=script&lang=js"
export * from "./supplierBankAction.vue?vue&type=script&lang=js"
import style0 from "./supplierBankAction.vue?vue&type=style&index=0&id=2dfed0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfed0a6",
  null
  
)

export default component.exports